"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadQRCodeWithLogo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const CTAFooter_1 = require("../CTAFooter");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const urls_1 = require("../../utils/urls");
const react_qrcode_logo_1 = require("react-qrcode-logo");
/**
 * used for generating QR code for downloading snapchat
 */
function DownloadQRCodeWithLogo(props) {
    const qrCodeValue = (0, react_1.useMemo)(() => {
        const pageTypeName = web_blizzard_reporting_1.PageType[props.pageType].toLowerCase();
        const iosAppStoreUrl = (0, urls_1.toAppStoreUrl)(pageTypeName);
        const webPageUrl = (0, urls_1.toWebDownloadPageUrl)(pageTypeName);
        const oneLinkParams = (0, CTAFooter_1.consumerWebOneLinkParams)(pageTypeName, urls_1.UNLOCK_DEEPLINK_URL, iosAppStoreUrl, webPageUrl);
        // we should never use this - but deeplink or open the download page in the off-chance
        const fallbackURL = `https://link.snapchat.com/download?web_client_id=${props.wcid}&trace_id=${props.traceId}`;
        return ((0, CTAFooter_1.tryGenerateOneLink)(oneLinkParams, props.wcid, props.traceId, {
            disableWebAfDp: true,
        }) || fallbackURL);
    }, [props.pageType, props.wcid, props.traceId]);
    return ((0, jsx_runtime_1.jsx)(react_qrcode_logo_1.QRCode, { size: 225, ecLevel: "L", bgColor: props.backgroundColor, logoImage: props.logoUrl, logoPadding: 5, logoPaddingStyle: "circle", value: qrCodeValue }));
}
exports.DownloadQRCodeWithLogo = DownloadQRCodeWithLogo;
//# sourceMappingURL=DownloadQrCodeWithLogo.js.map